import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "media-box" }
const _hoisted_2 = { class: "media-box-mini" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "intro-title" }
const _hoisted_5 = { class: "auther-title" }
const _hoisted_6 = { class: "intro-desc" }
const _hoisted_7 = { class: "links" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "user-outer-link"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-wechat" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.mediaInfo.primary_img,
        class: "media-logo",
        width: "100%"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.mediaInfo.title), 1),
      _createElementVNode("div", _hoisted_5, " 主理人:" + _toDisplayString(_ctx.mediaInfo.main_user), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.mediaInfo.short_desc), 1),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaInfo.links, (link, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            class: "user-outer-link"
          }, [
            (link.link)
              ? (_openBlock(), _createBlock(_component_ElTooltip, {
                  key: 0,
                  placement: "top"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createTextVNode("点击前往"),
                      _hoisted_8,
                      _createTextVNode(_toDisplayString(link.link), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: link.link,
                      target: "_blank"
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["iconfont", 'icon-'+link.type])
                      }, null, 2)
                    ], 8, _hoisted_9)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (link.name)
              ? (_openBlock(), _createBlock(_component_ElTooltip, {
                  key: 1,
                  placement: "top"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createTextVNode("请搜索"),
                      _hoisted_10,
                      _createTextVNode(_toDisplayString(link.name), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["iconfont", 'icon-'+link.type])
                    }, null, 2)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.mediaInfo.qrcode_img)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
              _createVNode(_component_ElTooltip, {
                effect: "light",
                "popper-class": "qr-code",
                placement: "top"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: _ctx.mediaInfo.qrcode_img
                    }, null, 8, _hoisted_12)
                  ])
                ]),
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}